/*
 * @Author: Nanxing Xiang
 * @Date: 2021-03-16 12:43:32
 * @LastEditors: Nanxing Xiang
 * @LastEditTime: 2021-09-01 11:15:18
 * @Description: file content
 */
import React from 'react';

var EasLoading = function EasLoading(_ref) {
  var type = _ref.type;

  if (type === 'dots') {
    return React.createElement("div", {
      className: "eas__loading loading__".concat(type)
    });
  }

  return null;
};

export default EasLoading;